import {
  getBasicSliceActions,
  getBasicCreateSingleAction,
  ActionParams,
} from '@probatix/common/utils/service'

import { getCurrentLocale } from '@probatix/common/translations'

import { API_MY_PROBATIX_ENTRYPOINT } from '@probatix/common/config/app'
import { Account, Username } from '../accountsService.model'
import { slice } from './accountsSingleService'

const URL = '/patients'

const returnHeader = () => ({
  Accept: 'application/json',
  'Accept-Language': getCurrentLocale().code.slice(0, 2),
  'Content-Type': 'application/json',
})

export const {
  accountsSingleFailed,
  accountsSingleFetching,
  accountsSingleSubmitting,
  accountsSingleSuccess,
} = getBasicSliceActions(slice.actions)

export const createAccount = (params: ActionParams<Account>): object => getBasicCreateSingleAction({
  customEntrypoint: API_MY_PROBATIX_ENTRYPOINT,
  customHeaders: returnHeader(),
  onError: accountsSingleFailed.type,
  onInit: accountsSingleSubmitting.type,
  onSuccess: accountsSingleSuccess.type,
  url: URL,
  withCredentials: false,
  ...params,
})

export const recoveryPassword = (data: ActionParams<Username>): object => getBasicCreateSingleAction({
  customEntrypoint: API_MY_PROBATIX_ENTRYPOINT,
  customHeaders: returnHeader(),
  onError: accountsSingleFailed.type,
  onInit: accountsSingleSubmitting.type,
  onSuccess: accountsSingleSuccess.type,
  url: `${URL}/request_reset_password`,
  withCredentials: false,
  ...data,
})
